import { render, staticRenderFns } from "./SidebarSpatial.vue?vue&type=template&id=2f4b31c3&"
import script from "./SidebarSpatial.vue?vue&type=script&lang=js&"
export * from "./SidebarSpatial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports